import React from "react";

import AssuranceDashbord from "../assurance/components/AssuranceDashbord";
import Assure from "../assurance/components/Assure";
import Contrats from "../assurance/components/Contrats";
import Module from "../assurance/components/Module";
import Partenaire from "../assurance/components/Partenaire";
import Personnel from "../assurance/components/Personnels";
import Police from "../assurance/components/Police";
import Structure from "../assurance/components/Structure";
import AssuranceDashbordLayout from "../assurance/pages/AssuranceDashboardLayout";
import { appRoutes } from "../constant/constant";

const AssuranceRoutes = [
  {
    path: "",
    element: <AssuranceDashbordLayout />,
    children: [
      /**route */
      {
        index: true,
        element: <AssuranceDashbord />,
      },
      {
        path: appRoutes.adminAssure,
        element: <Assure />,
      },
      {
        path: appRoutes.adminPolice,
        element: <Police />,
      },
      {
        path: appRoutes.module,
        element: <Module />,
      },
      /**route pour agent */
      {
        path: appRoutes.personnel,
        element: <Personnel />,
      },
      {
        path: appRoutes.contrats,
        element: <Contrats />,
      },
      {
        path: appRoutes.partenaire,
        element: <Partenaire />,
      },
      {
        path: appRoutes.structure,
        element: <Structure />,
      },

      /**route pour medecin */
    ],
  },
  {
    path: "*",
    element: <div>404 Not Found</div>,
  },
];

export default AssuranceRoutes;
